import { LongPaymentMethodSelect } from "components";
import { useFormContext } from "react-hook-form";

export enum PaymentMethodFormEnum {
  PaymentMethod = "paymentMethod",
}

const PaymentMethodStep = () => {
  const { watch, setValue } = useFormContext();

  const paymentMethodValue = watch(PaymentMethodFormEnum.PaymentMethod);

  return (
    <div className="space-y-4 pb-4 md:pb-10 border-b border-gray-200">
      <LongPaymentMethodSelect
        onChange={(payment) =>
          setValue(PaymentMethodFormEnum.PaymentMethod, payment)
        }
        value={paymentMethodValue}
      />
    </div>
  );
};

export default PaymentMethodStep;
